module.exports = __webpack_public_path__ + "348e9560f3cf0cfb0ad470ad3371772c.pdf";